// extracted by mini-css-extract-plugin
module.exports = {"button":"dece2e673c--button--FzUK3","icon":"dece2e673c--icon--yB9R1","XS":"dece2e673c--XS--JTpSd","M":"dece2e673c--M--TETjN"};